// extracted by mini-css-extract-plugin
export default {"container":"l8nDL_container","product-pic-top-brandPic-v2":"o_R3O_product-pic-top-brandPic-v2"};